import { mapState, mapActions } from "vuex";

import { STATUS_IMOVEL, OPERACAO_IMOVEL, PATH_IMAGENS_SITE } from "../../util/constantes";
import funcoes from "../../util/funcoes";

import AppSelecionarImovelDialog from "../../shared/dialogs/SelecionarImovelDialog.vue";
import AppSelecionarImagemCapaDialog from "./dialogs/SelecionarImagemCapaDialog.vue";
import AppUploadImagensCarrosselDialog from "./dialogs/UploadImagensCarrosselDialog.vue";
import AppUploadImagemBannerQuemSomos from "./dialogs/UploadImagemBannerQuemSomos.vue"
import AppUploadImagemBannerPrincipalView1 from "./dialogs/UploadImagemBannerPrincipalView1.vue"
import AppUploadImagemBannerPrincipalView2 from "./dialogs/UploadImagemBannerPrincipalView2.vue"
import AppAlterarLogoSiteDialog from './dialogs/AlterarLogoSiteDialog.vue';
import axios from 'axios';
import URLS from "../../util/urls";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faHome, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

library.add(faHome, faExternalLinkAlt);

export default {
  components: {
    AppSelecionarImovelDialog,
    AppSelecionarImagemCapaDialog,
    AppUploadImagensCarrosselDialog,
    AppUploadImagemBannerQuemSomos,
    AppUploadImagemBannerPrincipalView1,
    AppUploadImagemBannerPrincipalView2,
    AppAlterarLogoSiteDialog,
    FontAwesomeIcon
  },

  data() {
    return {
      tabSelecionada: 'destaques',

      tabSelecionadaImagens: 'imagensCarrossel',
      
      infiniteLoadingDestaquesPrincipaisId: 0,

      visibilidadeSelecionarImovelDestaquePrincipalDialog: false,
      visibilidadeSelecionarCapaDestaquePrincipalDialog: false,
      visibilidadeUploadImagensDialog: false,
      visibilidadeUploadImagemBannerQuemSomos: false,
      visibilidadeUploadImagemBannerPrincipalView1: false,
      visibilidadeUploadImagemBannerPrincipalView2: false,
      dialogAlterarLogoSiteIsVisible: false,

      imovelSelecionadoDestaquePrincipal: {},

      imagensViewerId: 0,

      remocaoImagens: {
        ativa: false,
        imagens: []
      },

      parametrosSite: {
        exibirEndereco: false,
        exibirCondominio: false,
        exibirCarrossel: false,
        urlPersonalizada: undefined,
        tituloFaleConosco: undefined,
        descricaoFaleConosco: undefined,
        chaveTagManager: undefined,
        chaveAnalitycs: undefined,
        chavePixel: undefined,
        chaveJivoChat: undefined,
        exibirIPTU: false,
        sloganCarrossel: undefined,
        imobiliaria:{
          id: 0,
          email: undefined,
          whatsappVenda: undefined,
          whatsappAluguel: undefined,
          celular: undefined,
          telefone: undefined
        },
        tituloServicos1: undefined,
        tituloServicos2: undefined,
        tituloServicos3: undefined,
        textoServicos1: undefined,
        textoServicos2: undefined,
        textoServicos3: undefined,
        quemSomos: undefined,
        missao: undefined,
        visao: undefined,
        valores: undefined
      },

      pathLogoSite: '',
      updateParam: 0,
    };
  },

  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado; }
    }),
    ...mapState("siteStore", {
      destaquesPrincipais(state) { return state.listaDestaquesPrincipais },
      labelQuantidadeDestaquesPrincipais(state) { return state.labelQuantidadeDestaquesPrincipais },
      listaImagensCarrossel(state) { return state.listaImagensCarrossel },
      legendaQuantidadeImoveisAluguelDestacados: state => state.legendaQuantidadeImoveisAluguelDestacados,
      legendaQuantidadeImoveisVendaDestacados: state => state.legendaQuantidadeImoveisVendaDestacados,
    }),

    funcoes() { return funcoes },
    statusImovel() { return STATUS_IMOVEL },
    operacoesImovel() { return OPERACAO_IMOVEL },

    destaquesAluguel(){ return this.destaquesPrincipais.filter(value => {
      return value.operacao == 'ALUGUEL';
    })},
    destaquesVenda(){ return this.destaquesPrincipais.filter(value => {
      return value.operacao == 'VENDA';
    })},

    modeloSite() {
      return this.usuarioLogado.imobiliaria.parametrosSite && 
             this.usuarioLogado.imobiliaria.parametrosSite.modelo;
    },

    isModuloAluguel() {
      return this.usuarioLogado.imobiliaria.moduloAluguel;
    },
    isModuloVenda() {
      return this.usuarioLogado.imobiliaria.moduloVenda;
    },

    isNenhumImovelDestacado() {
      return this.destaquesPrincipais.length === 0;
    },

    isVisibleLegendaQuantidadeImoveisAluguelDestacados() {
      return this.isModuloAluguel;
    },
    isVisibleLegendaQuantidadeImoveisVendaDestacados() {
      return this.isModuloVenda;
    },

    exibirBotaoCancelarRemocaoImagens() {
      return this.tabSelecionada === 'paginaInicial' && this.remocaoImagens.ativa;
    },
    exibirBotaoConcluirRemocaoImagens() {
      return this.tabSelecionada === 'paginaInicial' && this.remocaoImagens.ativa;
    },
    exibirAreaImagensCarrosselM3() {
      return this.usuarioLogado.imobiliaria.parametrosSite && 
             this.usuarioLogado.imobiliaria.parametrosSite.modelo && 
             this.usuarioLogado.imobiliaria.parametrosSite.modelo === 'MODELO_1' &&
             this.parametrosSite.exibirCarrossel;
    },

    exibirBotaoRemoverImagens() {
      return this.tabSelecionada === 'paginaInicial' && this.listaImagensCarrossel.length > 0 && !this.remocaoImagens.ativa;
    },
    exibirBotaoAdicionarImagens() {
      return (this.tabSelecionada === 'paginaInicial' && this.listaImagensCarrossel.length <= 5 && this.exibirBotaoRemoverImagens) || this.listaImagensCarrossel.length === 0;
    },

    MsgNenhumaImagem(){
      return "Nenhuma Imagem";
    },    
    checkboxExibirCarrosselIsVisible() {
      return this.usuarioLogado.imobiliaria.parametrosSite && 
             this.usuarioLogado.imobiliaria.parametrosSite.modelo && 
             this.usuarioLogado.imobiliaria.parametrosSite.modelo === 'MODELO_1';
    },

    campoUrlPersonalizadaIsVisible() {
        return this.parametrosSite.exibirCarrossel == true;
    }
  },

  created() {
    this.handleRecuperarParametrosSite();
    this.configurarThumbnailLogoSiteInicial();
  },

  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading",
    ]),

    ...mapActions('loginStore', [
      'relogar',
    ]),

    ...mapActions("siteStore", [
      "recuperarDestaquesPrincipais",
      "gravarDestaquePrincipal",
      "removerDestaquePrincipal",
      "recuperarImagensCarrossel",
      "removerImagensCarrossel",
      "removerImagemBannerQuemSomos",
      "removerImagemBannerPrincipalView1",
      "removerImagemBannerPrincipalView2"
    ]),

    exibirSelecionarImovelDestaquePrincipalDialog() {
      this.visibilidadeSelecionarImovelDestaquePrincipalDialog = true;
    },
    fecharSelecionarImovelDestaquePrincipalDialog(imovelSelecionado) {
      this.visibilidadeSelecionarImovelDestaquePrincipalDialog = false;

      if(!imovelSelecionado) {
        return;
      }
    
      if(this.verificarQuantidadeImoveis(imovelSelecionado)) {
        this.exibirAlerta(`Você excedeu a quantidade máxima de 6 imóveis de ${imovelSelecionado.operacao.toLowerCase()}.`);
        return;
      }

      this.imovelSelecionadoDestaquePrincipal = imovelSelecionado;
      this.exibirSelecionarCapaDestaquePrincipalDialog();
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'error' });
    },

    exibirSelecionarCapaDestaquePrincipalDialog() {
      this.visibilidadeSelecionarCapaDestaquePrincipalDialog = true;
    },
    fecharSelecionarCapaDestaquePrincipalDialog(imagemSelecionada) {
      this.visibilidadeSelecionarCapaDestaquePrincipalDialog = false;

      if(imagemSelecionada) {
        this.imovelSelecionadoDestaquePrincipal.imagemCapa = imagemSelecionada;
        this.adicionarDestaquePrincipal();
      }
    },

    verificarQuantidadeImoveis(imovelSelecionado) {
      const tipo = imovelSelecionado.operacao;

      const imoveisAdicionados = this.destaquesPrincipais.filter(value => {
        return value.operacao == tipo;
      })
      
      return imoveisAdicionados.length >= 6
    },

    recuperarDestaquesPrincipaisHandler($state) {
      this.recuperarImagensCarrossel()
      this.showLoading();
      this.recuperarDestaquesPrincipais({}).then((resultado) => {
        this.hideLoading();

        if(resultado.lista.length > 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    adicionarDestaquePrincipal() {
      const imovel = this.imovelSelecionadoDestaquePrincipal;

      this.showLoading();
      this.gravarDestaquePrincipal(imovel).then((resultado) => {
        this.hideLoading();
        
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    removerDestaquePrincipalConfirm(imovel) {
      this.$confirm("Tem certeza que deseja remover este Destaque Principal?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.removerDestaquePrincipalHandler(imovel);
      }).catch(() => {});
    },

    removerDestaquePrincipalHandler(imovel) {
      this.showLoading();

      this.removerDestaquePrincipal(imovel).then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();

        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    //IMAGENS
    exibirDialogUploadImagens() {
      this.visibilidadeUploadImagensDialog = true;
    },
    fecharDialogUploadImagens() {
      this.visibilidadeUploadImagensDialog = false;
      this.recuperarImagensCarrossel();
    },

    exibirDialogUploadImagensBannerQuemSomos() {
      this.visibilidadeUploadImagemBannerQuemSomos = true;
    },
    fecharDialogUploadImagensBannerQuemSomos() {
      this.visibilidadeUploadImagemBannerQuemSomos = false;
    },

    exibirDialogUploadImagensBannerPrincipalView1() {
      this.visibilidadeUploadImagemBannerPrincipalView1 = true;
    },
    fecharDialogUploadImagensBannerPrincipalView1() {
      this.visibilidadeUploadImagemBannerPrincipalView1 = false;
    },

    exibirDialogUploadImagensBannerPrincipalView2() {
      this.visibilidadeUploadImagemBannerPrincipalView2 = true;
    },
    fecharDialogUploadImagensBannerPrincipalView2() {
      this.visibilidadeUploadImagemBannerPrincipalView2 = false;
    },

    imagemClickHandler(indice) {
      if(this.remocaoImagens.ativa) { this.adicionarImagemParaRemocao(indice); }
      else { this.imagemSelecionada = indice; }
      this.imagemSelecionada = indice;      
    },

    adicionarImagemParaRemocao(indice) {
      if(this.remocaoImagens.imagens.includes(this.listaImagensCarrossel[indice])) {
        this.remocaoImagens.imagens = this.remocaoImagens.imagens.filter((imagem) => { return imagem.id != this.listaImagensCarrossel[indice].id });
      } else {
        this.remocaoImagens.imagens.push(this.listaImagensCarrossel[indice]);
      }
    },
    iniciarRemocaoImagensHandler() {
      this.remocaoImagens.ativa = true;
      this.remocaoImagens.imagens = [];
    },
    concluirRemocaoImagensHandler() {
      if(this.remocaoImagens.imagens.length == 0) { this.cancelarRemocaoImagensHandler(); return; }

      this.$confirm("Deseja realmente remover as imagens selecionadas?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.removerImagens();
      }).catch(() => {
        this.cancelarRemocaoImagensHandler();
      });
    },
    removerImagens() {
      const payload = {
        imagens: this.remocaoImagens.imagens
      }

      this.showLoading();
      this.removerImagensCarrossel(payload)
      .then((resultado) => {
        this.hideLoading();
        this.cancelarRemocaoImagensHandler();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.recuperarImagensCarrossel();
            break;
          case "FALHA":
          case "ERRO":
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.cancelarRemocaoImagensHandler();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    cancelarRemocaoImagensHandler() {
      this.remocaoImagens.ativa = false;
      this.remocaoImagens.imagens = [];
    },

    removerBannerQuemSomosHandler() {
      this.showLoading();
      const payload = {
        ...this.parametrosSite
      }

      this.removerImagemBannerQuemSomos(payload)
      .then((response) => {
        if(response.status === "SUCESSO") {
          this.parametrosSite.bannerQuemSomos = undefined;
          this.$message.error(response.mensagem);
        }

        if(response.status === "ERRO") {
          this.$message.error(response.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      }).finally(() => {
        this.hideLoading();
      })
    },

    removerBannerPrincipalView1Handler() {
      this.showLoading();
      const payload = {
        ...this.parametrosSite
      }

      this.removerImagemBannerPrincipalView1(payload)
      .then((response) => {
        if(response.status === "SUCESSO") {
          this.parametrosSite.bannerQuemSomos = undefined;
          this.$message.error(response.mensagem);
        }

        if(response.status === "ERRO") {
          this.$message.error(response.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      }).finally(() => {
        this.hideLoading();
      })
    },

    removerBannerPrincipalView2Handler() {
      this.showLoading();
      const payload = {
        ...this.parametrosSite
      }

      this.removerImagemBannerPrincipalView2(payload)
      .then((response) => {
        if(response.status === "SUCESSO") {
          this.parametrosSite.bannerQuemSomos = undefined;
          this.$message.error(response.mensagem);
        }

        if(response.status === "ERRO") {
          this.$message.error(response.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      }).finally(() => {
        this.hideLoading();
      })
    },

    corBordaOrdenacao(indice) {
      if(this.remocaoImagens.ativa) {
        if(this.remocaoImagens.imagens.includes(this.listaImagensCarrossel[indice])) {
          return "#F56C6C";
        } else {
          return "#FFFFFF";
        }
      } else {
        return "#FFFFFF";
      }
    },

    configurarThumbnailLogoSite(nomeArquivo) {
      this.pathLogoSite = `${PATH_IMAGENS_SITE}${nomeArquivo}?u=${++this.updateParam}`;
    },

    configurarThumbnailLogoSiteInicial() {
      const nomeArquivo = this.usuarioLogado.imobiliaria.imagemSite;
      this.configurarThumbnailLogoSite(nomeArquivo);
    },

    handleRecuperarParametrosSite() {
      this.showLoading();

      this.recuperarParametrosSite().then(resultado => {
        switch (resultado.status) {
          case 'SUCESSO':
            this.atualizarParametrosSite(resultado.item);
            break;
        
          case 'ERRO':
            this.$message.error("Ocorreu um erro ao recuperar os parâmetros");
            break;
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }).finally(() => {
        this.hideLoading();
      });
    },

    atualizarParametrosSite(parametros) {
      this.parametrosSite.exibirEndereco = parametros.exibirEndereco;
      this.parametrosSite.exibirCondominio = parametros.exibirCondominio;
      this.parametrosSite.exibirCarrossel = parametros.exibirCarrossel;
      this.parametrosSite.urlPersonalizada = parametros.urlPersonalizada;
      this.parametrosSite.tituloFaleConosco = parametros.tituloFaleConosco;
      this.parametrosSite.descricaoFaleConosco = parametros.descricaoFaleConosco;
      this.parametrosSite.chaveTagManager = parametros.chaveTagManager;
      this.parametrosSite.chaveAnalitycs = parametros.chaveAnalitycs;
      this.parametrosSite.chavePixel = parametros.chavePixel;
      this.parametrosSite.chaveJivoChat = parametros.chaveJivoChat;
      this.parametrosSite.exibirIPTU = parametros.exibirIPTU;
      this.parametrosSite.sloganCarrossel = parametros.sloganCarrossel;
      this.parametrosSite.imobiliaria.id = parametros.imobiliaria.id;
      this.parametrosSite.imobiliaria.email = parametros.imobiliaria.email;
      this.parametrosSite.imobiliaria.celular = parametros.imobiliaria.celular;
      this.parametrosSite.imobiliaria.whatsappAluguel = parametros.imobiliaria.whatsappAluguel;
      this.parametrosSite.imobiliaria.whatsappVenda = parametros.imobiliaria.whatsappVenda;
      this.parametrosSite.imobiliaria.telefone = parametros.imobiliaria.telefone;
      this.parametrosSite.tituloServicos1 = parametros.tituloServicos1;
      this.parametrosSite.tituloServicos2 = parametros.tituloServicos2;
      this.parametrosSite.tituloServicos3 = parametros.tituloServicos3;
      this.parametrosSite.textoServicos1 = parametros.textoServicos1;
      this.parametrosSite.textoServicos2 = parametros.textoServicos2;
      this.parametrosSite.textoServicos3 = parametros.textoServicos3;
      this.parametrosSite.quemSomos = parametros.quemSomos;
      this.parametrosSite.missao = parametros.missao;
      this.parametrosSite.visao = parametros.visao;
      this.parametrosSite.valores = parametros.valores;
      this.parametrosSite.bannerQuemSomos = parametros.bannerQuemSomos;
      this.parametrosSite.bannerPrincipalView1 = parametros.bannerPrincipalView1;
      this.parametrosSite.bannerPrincipalView2 = parametros.bannerPrincipalView2;
    },

    recuperarParametrosSite() {
      return axios.get(URLS.IMOBILIARIAS_RECUPERAR_PARAMETROS_SITE)
        .then(response => {
          switch (response.data.status) {
            case 'SESSAO_EXPIRADA':
              return this.relogar().then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.recuperarParametrosSite();
                }
              }).catch(error => {
                throw error;
              });
            
            default:
              return response.data;
          }
        }).catch(error => {
          throw error;
        });
    },

    handleGravarParametrosSite() {
      this.showLoading();

      const payload = this.montarPayloadGravarParametrosSite();

      this.gravarParametrosSite(payload).then(resultado => {
        switch (resultado.status) {
          case 'SUCESSO':
            this.$message.success(resultado.mensagem);
            break;
        
          case 'ERRO':
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }).finally(() => {
        this.hideLoading();
      });
    },

    gravarParametrosSite(payload) {
      return axios.post(URLS.IMOBILIARIAS_GRAVAR_PARAMETROS_SITE, payload).then(response => {
        switch (response.data.status) {
          case 'SESSAO_EXPIRADA':
            return this.relogar().then(authResponse => {
              if(authResponse.status === 'SUCESSO') {
                return this.gravarParametrosSite(payload);
              }
            }).catch(error => {
              throw error;
            });
          
          default:
            return response.data;
        }
      }).catch(error => {
        throw error;
      });
    },

    montarPayloadGravarParametrosSite() {
      return {
        modelo: this.modeloSite,
        exibirEndereco: this.parametrosSite.exibirEndereco,
        exibirCondominio: this.parametrosSite.exibirCondominio,
        exibirCarrossel: this.parametrosSite.exibirCarrossel,
        urlPersonalizada: this.parametrosSite.urlPersonalizada,
        tituloFaleConosco: this.parametrosSite.tituloFaleConosco,
        descricaoFaleConosco: this.parametrosSite.descricaoFaleConosco,
        chaveTagManager: this.parametrosSite.chaveTagManager,
        chaveAnalitycs: this.parametrosSite.chaveAnalitycs,
        chavePixel: this.parametrosSite.chavePixel,
        chaveJivoChat: this.parametrosSite.chaveJivoChat,
        exibirIPTU: this.parametrosSite.exibirIPTU,
        sloganCarrossel: this.parametrosSite.sloganCarrossel
      };
    },

    handleGravarDadosImobiliariaSite() {
      this.showLoading();

      const payload = this.montarPayloadGravarDadosImobiliariaSite();

      this.gravarDadosImobiliariaSite(payload).then(resultado => {
        switch (resultado.status) {
          case 'SUCESSO':
            this.$message.success(resultado.mensagem);
            break;
        
          case 'ERRO':
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }).finally(() => {
        this.hideLoading();
      });
    },

    gravarDadosImobiliariaSite(payload) {
      return axios.post(URLS.IMOBILIARIAS_GRAVAR_DADOS_IMOBILIARIA_SITE, payload).then(response => {
        switch (response.data.status) {
          case 'SESSAO_EXPIRADA':
            return this.relogar().then(authResponse => {
              if(authResponse.status === 'SUCESSO') {
                return this.gravarDadosImobiliariaSite(payload);
              }
            }).catch(error => {
              throw error;
            });
          
          default:
            return response.data;
        }
      }).catch(error => {
        throw error;
      });
    },

    montarPayloadGravarDadosImobiliariaSite() {
      return {
        tituloFaleConosco: this.parametrosSite.tituloFaleConosco,
        descricaoFaleConosco: this.parametrosSite.descricaoFaleConosco,
        imobiliaria: {
          id: this.parametrosSite.imobiliaria.id,
          email: this.parametrosSite.imobiliaria.email,
          celular: this.parametrosSite.imobiliaria.celular,
          telefone: this.parametrosSite.imobiliaria.telefone,
          whatsappAluguel: this.parametrosSite.imobiliaria.whatsappAluguel,
          whatsappVenda: this.parametrosSite.imobiliaria.whatsappVenda
        },
        quemSomos: this.parametrosSite.quemSomos,
        missao: this.parametrosSite.missao,
        visao: this.parametrosSite.visao,
        valores: this.parametrosSite.valores,
        tituloServicos1: this.parametrosSite.tituloServicos1,
        tituloServicos2: this.parametrosSite.tituloServicos2,
        tituloServicos3: this.parametrosSite.tituloServicos3,
        textoServicos1: this.parametrosSite.textoServicos1,
        textoServicos2: this.parametrosSite.textoServicos2,
        textoServicos3: this.parametrosSite.textoServicos3,
      }  
    },

    handleClickButtonAlterarLogoSite() {
      this.exibirDialogAlterarLogoSite();
    },

    exibirDialogAlterarLogoSite() {
      this.dialogAlterarLogoSiteIsVisible = true;
    },
    fecharDialogAlterarLogoSite() {
      this.dialogAlterarLogoSiteIsVisible = false;
    },
    alterarLogoSite(resultado) {
      const nomeArquivo = resultado.item.imagemSite;
      this.configurarThumbnailLogoSite(nomeArquivo);

      this.dialogAlterarLogoSiteIsVisible = false;
    },
    exibirQuantidadeImagens(){
      switch(this.listaImagensCarrossel.length){
        case 0: return "Nenhuma Imagem encontrada"
        default: return `${this.listaImagensCarrossel.length} / 6 Imagen(s) adicionada(s)`

      }  
    },

    exibirImagensSelecionadasRemocao(){
      let auxSingular = "";

      if(this.remocaoImagens.imagens.length === 1){ 
        auxSingular = " imagem selecionada de " 
      }else if(this.remocaoImagens.imagens.length > 1){
        auxSingular = " imagens selecionadas de "
      }else{return "Nenhuma imagem selecionada"}

      return this.remocaoImagens.imagens.length + auxSingular + this.listaImagensCarrossel.length;
    }
  },
}